import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "11",
  fill: "#1A53F0",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M.822 3.147L7.29 6.51a.455.455 0 00.42 0l6.469-3.364v5.844a1.973 1.973 0 01-1.862 1.97l-.111.003H2.795a1.973 1.973 0 01-1.97-1.861L.822 8.99V3.147zM2.795.036h9.41a1.973 1.973 0 011.97 1.861l.004.112v.112L7.5 5.593.822 2.121v-.112A1.973 1.973 0 012.683.039l.112-.003h9.41-9.41z" }, null, -1 /* HOISTED */)
  ])))
}